import { SearchType } from '@aibees/elephant/types';
import { IconName } from '@aibees/shared/components';
import { useMemo } from 'react';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { usePageType } from '../use-page-type';

interface UseLabelDialogConfigParams {
  isLabel: boolean;
  isEdit?: boolean;
  searchTypeOverride?: SearchType;
}

export function useLabelDialogConfig({
  isLabel,
  isEdit,
  searchTypeOverride,
}: UseLabelDialogConfigParams) {
  const type = useSearchTypeFromRoute();
  const { isPeoplePage } = usePageType();
  const searchType = useMemo(() => {
    if (searchTypeOverride) return searchTypeOverride;
    if (isPeoplePage) return SearchType.People;
    return type;
  }, [searchTypeOverride, isPeoplePage, type]);

  const entityTypeName = useMemo(
    () => (searchType === SearchType.People ? 'Contact' : 'Account'),
    [searchType]
  );

  const titleDialog = useMemo(
    () =>
      isLabel
        ? isEdit
          ? `Edit ${entityTypeName} Label`
          : `Create ${entityTypeName} Label`
        : isEdit
        ? `Edit ${entityTypeName} List`
        : `Create ${entityTypeName} List`,
    [isLabel, isEdit, entityTypeName]
  );
  const inputTitle = useMemo(
    () => (isLabel ? 'Label Name:' : 'List Name:'),
    [isLabel]
  );
  const dialogIcon: IconName = useMemo(
    () => (isEdit ? 'edit-outline' : isLabel ? 'label-outline' : 'list'),
    [isLabel, isEdit]
  );

  const placeholder = useMemo(
    () =>
      isLabel ? 'Enter a name for your label…' : 'Enter a name for your list…',
    [isLabel]
  );

  return {
    titleDialog,
    inputTitle,
    dialogIcon,
    placeholder,
  };
}
